import React from 'react';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';
import { useT } from '../i18n/LanguageContext';

export default function FAQ() {
  const { t } = useT();

  const items = [1, 2, 3, 4, 5, 6].map((i) => ({
    q: t(`faq.q${i}`),
    a: t(`faq.a${i}`),
  }));

  return (
    <section id="faq" className="py-24 uc-mint-bg">
      <div className="max-w-3xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-12">
          <p className="uc-kicker mb-3">{t('faq.kicker')}</p>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-[#1a2851]">
            {t('faq.heading1')} <span className="text-[#4dbfae]">{t('faq.heading2')}</span>
          </h2>
        </div>

        <Accordion type="single" collapsible className="space-y-3">
          {items.map((it, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              className="bg-white rounded-xl border border-[#eef6f4] px-5 data-[state=open]:border-[#4dbfae]/40 data-[state=open]:shadow-sm"
            >
              <AccordionTrigger className="text-left font-semibold text-[#1a2851] hover:no-underline py-4">
                {it.q}
              </AccordionTrigger>
              <AccordionContent className="text-[#5b6469] leading-relaxed pb-4">
                {it.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
